// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"767":"css/libs","864":"css/inline-layout/inline-layout","2615":"css/pdf","8266":"css/style"}[chunkId] + ".css";
};